import React from "react";
import { ReactComponent as YourThreadsIcon } from "../../../../assets/icons/YourThreads.svg";
import { ReactComponent as SavedIcon } from "../../../../assets/icons/Bookmarks.svg";

const LibraryCard = ({ showUserQuests, setShowUserQuests, fetchUserQuests }) => {
  const handleToggle = async () => {
    if (!showUserQuests) {
      await fetchUserQuests();
    } else {
      setShowUserQuests(false);
    }
  };

  return (
    <div className="bg-white rounded-[36px] shadow-md p-4 flex flex-col gap-4 w-full max-w-[18rem]">

      {/* Toggle Quests Button */}
      <button
        onClick={handleToggle}
        className="group flex items-center gap-3 w-full hover:bg-cyan-50 active:scale-[0.98] transition-all rounded-2xl px-3 py-2"
      >
        <div className="w-8 h-8 bg-neutral-200 rounded-xl flex items-center justify-center">
          <YourThreadsIcon className="w-5 h-5 text-neutral-600" />
        </div>
        <span className="text-stone-900 text-sm font-semibold font-['Poppins'] group-hover:text-cyan-600">
          {showUserQuests ? "Public Quests" : "Your Quests"}
        </span>
      </button>

      {/* Saved Button */}
      <button className="group flex items-center gap-3 w-full hover:bg-cyan-50 active:scale-[0.98] transition-all rounded-2xl px-3 py-2">
        <div className="w-8 h-8 bg-neutral-200 rounded-xl flex items-center justify-center">
          <SavedIcon className="w-4 h-4 text-neutral-600" />
        </div>
        <span className="text-stone-900 text-sm font-semibold font-['Poppins'] group-hover:text-cyan-600">
          Saved
        </span>
      </button>
    </div>
  );
};

export default LibraryCard;
